import Resource from "../base/resource";
import Model from "../model/model";

class HelperObject extends Resource {
    name;
    id;

    constructor(props) {
        super(props);
        this.name = props.name;
        this.id = props.id;
        this.objectType = props.objectType;
        this._model = new Model({
            ...props,
            resourceId: props.id,
        });
        this._model.name = props.name;
    }

    async load(onLoadCallback) {
        if (wv.effectController.stoppedTrainingId === TrainingTreeController._trainingFeature.getActiveTraining()?.id) {
            return;
        }

        console.log('Loading helper object: ', this.name);
        if (getModelObject(this.id)) { // already loaded
            onLoadCallback(1);
            const helperObjectModel = modelManager.getModelById(this.id);
            const animationDuration = wv.effectController.serverlessEditorLoadingState ? 0 : undefined;
            processVisibilityMessage(undefined, helperObjectModel.nameNodeMap[helperObjectModel.name], SelectionActionApplyToType.Model, false, false, undefined, animationDuration);
            return;
        }

        await HelperObjectManager.addHelperObject({
            modelId: this.id,
            modelName: this.name,
            objectType: this.objectType,
        });

        for (; ;) {
            if (!getModelObject(this.id)) {
                await sleep(500);
                continue;
            }

            onLoadCallback(1);

            if (wv.effectController.serverlessEditorLoadingState) {
                return;
            }

            const helperObjectModel = modelManager.getModelById(this.id);
            processVisibilityMessage(undefined, helperObjectModel.nameNodeMap[helperObjectModel.name], SelectionActionApplyToType.Model, false, false);
            return;
        }
    }

    prepareState(state) {
        super.prepareState(state);
        this._model.prepareState(state);
    }

    setState(state, options) {
        this.handleColorState(state);
        this._model.setState(state, options);
    }

    handleColorState(state) {
        // Helper Objects have only one volume
        const branchId = modelManager.getVolumesByModelId(this.id)[0].branchID;

        if (!state?.color) {
            HelperObjectManager.resetColor(this.id, branchId);
            return;
        }

        const color = {
            r: state.color.hasOwnProperty('r') ? state.color.r : 1,
            g: state.color.hasOwnProperty('g') ? state.color.g : 1,
            b: state.color.hasOwnProperty('b') ? state.color.b : 1
        };
        HelperObjectManager.changeColor(this.id, branchId, color);
    }

    mergeStates(initialState) {
        const finalState = this._model.mergeStates(initialState);

        this.states.forEach(state => {
            finalState.color = state.color ? state.color : finalState.color;
        });

        return finalState;
    }

    getDefaultState() {
        return {
            ...this._model.getDefaultState(),
            color: null,
        };
    }
}

export default HelperObject;
